export const removeHTMLTags = (value: string) => value?.replace(/(<([^>]+)>)/gi, '') ?? '';

export const removeHTMLTagsAndWhitespaces = (value: string) => removeHTMLTags(value).trim().replace(/\s\s+/g, ' ');
